// Constants
// Utilities
import { normalizeOrderHint } from "../../../utilities/OrderHintUtilties";
/**
 * Implementation of ITaskPersonalViewOrderHints
 */ export class TaskPersonalViewOrderHints {
    /**
     * Creates an instance of TaskPersonalViewOrderHints from legacy data.
     * @param assigneePriority The assignee priority from legacy data.
     */ static fromLegacyData(assigneePriority) {
        // For personal view legacy data, we only have assigneePriority
        // This maps to the main order hint (None grouping)
        return new TaskPersonalViewOrderHints(!assigneePriority ? null : assigneePriority);
    }
    get(grouping) {
        return this.orderHint;
    }
    set(grouping, value) {
        return new TaskPersonalViewOrderHints(value);
    }
    forSerialization() {
        return {
            assigneePriority: this.orderHint ?? undefined
        };
    }
    constructor(orderHint){
        this.orderHint = orderHint === null ? null : normalizeOrderHint(orderHint);
    }
}
